import { BarChart2 } from 'lucide-react'
import { StubPage } from './StubPage'

export function StatsPage() {
  return (
    <StubPage
      title="Stats"
      icon={BarChart2}
      phase="Coming in Phase 3 — admin dashboard rollout"
      description={
        <>
          A "System overview" dashboard lands here: four cards
          (Companies / Active users / Total leads / Total deals) plus a workspace
          filter that swaps the cards to per-tenant numbers.
          <br />
          <br />
          Backed by a new <code>GET /admin/stats/overview</code> endpoint with one
          SQL query per metric (no fan-out). Charts are a v2 add — v1 is just
          numbers. When the workspace filter is active, the section heading switches
          off "System overview" so scoped numbers don't read as global.
        </>
      }
    />
  )
}
